module.exports = __webpack_public_path__ + "static/media/SFProText-LightItalic.27193296.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-LightItalic.ttf
// module id = 2546
// module chunks = 7